import { Observable } from 'rxjs';
import { IBaseService } from '@pit/core';
import { IDtoUser } from '@pit/frontend-model';

export interface ICommunicationDataService extends IBaseService {

    sendMessageToDevices$(message: string, expiresAt: Date, devices: string[]): Observable<boolean>;
    sendMessageToDevicesAsync(message: string, expiresAt: Date, devices: string[]): Promise<boolean>;

    sendMessageToDepots$(mandator: string, message: string, expiresAt: Date, depots: string[]): Observable<boolean>;
    sendMessageToDepotsAsync(mandator: string, message: string, expiresAt: Date, depots: string[]): Promise<boolean>;

    sendShipmentsLoadAssignedForDevice$(deviceId: string, expiresAt: Date): Observable<boolean>;
    sendShipmentsLoadAssignedForDeviceAsync(deviceId: string, expiresAt: Date): Promise<boolean>;

    sendDeviceLogout$(deviceId: string, expiresAt: Date): Observable<boolean>;
    sendDeviceLogoutAsync(deviceId: string, expiresAt: Date): Promise<boolean>;

    sendDeviceReset$(deviceId: string, expiresAt: Date): Observable<boolean>;
    sendDeviceResetAsync(deviceId: string, expiresAt: Date): Promise<boolean>;

    sendDeviceFinishWorkDay$(deviceId: string, expiresAt: Date): Observable<boolean>;
    sendDeviceFinishWorkDayAsync(deviceId: string, expiresAt: Date): Promise<boolean>;

    requestDeviceBatteryInfo$(deviceId: string, expiresAt: Date): Observable<boolean>;
    requestDeviceBatteryInfoAsync(deviceId: string, expiresAt: Date): Promise<boolean>;

    requestDeviceSync$(deviceId: string, expiresAt: Date): Observable<boolean>;
    requestDeviceSyncAsync(deviceId: string, expiresAt: Date): Promise<boolean>;

    requestDeviceAppExit$(deviceId: string, expiresAt: Date): Observable<boolean>;
    requestDeviceAppExitAsync(deviceId: string, expiresAt: Date): Promise<boolean>;

    requestDeviceAppLock$(deviceId: string, expiresAt: Date): Observable<boolean>;
    requestDeviceAppLockAsync(deviceId: string, expiresAt: Date): Promise<boolean>;

    requestDeviceAppUnlock$(deviceId: string, expiresAt: Date): Observable<boolean>;
    requestDeviceAppUnlockAsync(deviceId: string, expiresAt: Date): Promise<boolean>;

    requestDeviceAppUnlockHome$(deviceId: string, expiresAt: Date): Observable<boolean>;
    requestDeviceAppUnlockHomeAsync(deviceId: string, expiresAt: Date): Promise<boolean>;

    requestDeviceHttpModeOptions$(deviceId: string, expiresAt: Date, httpMode: string, httpModeSingleton: boolean): Observable<boolean>;
    requestDeviceHttpModeOptionsAsync(deviceId: string, expiresAt: Date, httpMode: string, httpModeSingleton: boolean): Promise<boolean>;

    requestDeviceLoadSettings$(deviceId: string, expiresAt: Date): Observable<boolean>;
    requestDeviceLoadSettingsAsync(deviceId: string, expiresAt: Date): Promise<boolean>;

    requestDeviceBackgroundFetch$(deviceId: string, expiresAt: Date, fetchOn: boolean): Observable<boolean>;
    requestDeviceBackgroundFetchAsync(deviceId: string, expiresAt: Date, fetchOn: boolean): Promise<boolean>;

    requestDevicePosition$(deviceId: string, expiresAt: Date): Observable<boolean>;
    requestDevicePositionAsync(deviceId: string, expiresAt: Date): Promise<boolean>;

}
